import { gql } from '@apollo/client'

export const GET_USERS = gql`
  query GetUsers {
    users {
      id
      name
      email
      status
      UserRole {
        roleId
        userId
        role {
          roleName
        }
      }
    }
  }
`

export const GET_SESSIONS_BY_CHAT_ROOM_ID = gql`
  query SessionsByChatRoomId($input: ChatRoomIdInput!) {
    sessionsByChatRoomId(input: $input) {
      id
      chatRoomId
      assignedAgentId
      startDate
      endDate
      botName
      messageRequest {
        id
        sessionId
        content
        inputType
        prevRequestId
        templateId
        intentId
        time
      }
      agentName
    }
  }
`

export const GET_CHAT_ROOMS = gql`
  query ChatRooms($input: GetAllChatRoomsFilterInput) {
    chatRooms(input: $input) {
      status
      message
      data
    }
  }
`

export const GET_CHAT_ROOM_META_BY_CHATROOM_ID = gql`
  query ChatRoomMetaByChatRoomId($input: ChatRoomIdInput!) {
    chatRoomMetaByChatRoomId(input: $input) {
      id
      name
      value
    }
  }
`

export const VALIDATE_MEMBER_INVITATION = gql`
  query ValidateMemberInvitation($input: ValidateMemberInviteInput!) {
    validateMemberInvitation(input: $input) {
      status
      message
      data
    }
  }
`

export const GET_TEAMS = gql`
  query GetTeams {
    getTeams {
      id
      name
      description
      modifiedAt
      createdAt
    }
  }
`

export const GET_USERS_BY_TEAM_ID = gql`
  query GetUsersByTeamId($input: GetUsersByTeamIdInput!) {
    getUsersByTeamId(input: $input) {
      id
      name
      email
      status
      UserRole {
        roleId
        userId
      }
    }
  }
`

export const GET_ACTIVE_USERS_NOT_IN_TEAM = gql`
  query GetActiveUsersNotInTeam {
    getActiveUsersNotInTeam {
      id
      name
      email
      status
      UserRole {
        roleId
        userId
      }
    }
  }
`

export const GET_BOT_ANALYTICS = gql`
  query BotAnalytics {
    botAnalytics {
      status
      message
      data
    }
  }
`

export const GET_GRAPH_ANALYTICS = gql`
  query GraphAnalytics($input: GetBotAnalyticsInputs) {
    graphAnalytics(input: $input) {
      graphData
    }
  }
`

export const GET_ALL_APPLICATION_IDS = gql`
  query AllApplicationId($input: AllApplicationIdInput) {
    allApplicationId(input: $input) {
      id
      bgAccountId
      appIDString
      appName
      startDate
      endDate
    }
  }
`

export const GET_BG_ACCOUNT_BY_ID = gql`
  query GetBgAccountById {
    getBgAccountById {
      id
      organization
      location
      teamSize
      companySize
      industry
      logo
      registeredAddress
      typeOfCompany
      dateOfIncorporation
      businessContactNumber
      CIN
      PAN
      TAN
      GSTIN
    }
  }
`

export const GET_BG_ACCOUNT_BY_BG_ID = gql`
  query GetBgAccountById {
    getBgAccountById {
      id
    }
  }
`

export const GET_ALL_APPLICATIONS = gql`
  query AllApplicationId($input: AllApplicationIdInput) {
    allApplicationId(input: $input) {
      id
      appIDString
      appName
      config
      input
      botName
      botDescription
      startDate
      endDate
    }
  }
`

export const GET_BOT_TEMPLATES = gql`
  query GetTemplates($input: TemplateInput) {
    getTemplates(input: $input) {
      id
      bgAccountId
      inputJson
      configJson
      templateType
      templateName
      description
      useCase
      industryTypes
      imageLink
    }
  }
`
export const GET_USER_BY_ID = gql`
  query GetUserById {
    getUserById {
      id
      name
      email
      status
      contactNumber
      Designation
      Department
      emailVerified
      onboardingDone
      UserRole {
        roleId
        userId
      }
      franchiseId
      teamId
    }
  }
`
export const LEAD_GENERATION = gql`
  query LeadGeneration($input: LeadGenerationInput) {
    leadGeneration(input: $input) {
      leadGeneration
    }
  }
`

export const GET_TEMPLATES = gql`
  query GetTemplates($input: TemplateInput) {
    getTemplates(input: $input) {
      id
      bgAccountId
      inputJson
      configJson
      templateType
      templateName
      description
      useCase
      industryTypes
      imageLink
    }
  }
`

export const GET_ALL_BG_ACCOUNTS = gql`
  query GetAllBgAccounts($input: GetBgAccountsByFranchiseInput) {
    getAllBgAccounts(input: $input) {
      count
      bgAccounts {
        id
        organization
        location
        teamSize
        companySize
        industry
        logo
        registeredAddress
        typeOfCompany
        dateOfIncorporation
        businessContactNumber
        CIN
        PAN
        TAN
        GSTIN
      }
    }
  }
`

export const GET_PLAN_DETAILS_BY_BG_ACCOUNT_ID = gql`
  query GetPlanDetailsByBgAccountId($input: planDetailsByBgAccountIdInputType!) {
    getPlanDetailsByBgAccountId(input: $input) {
      planDetails {
        plans
        createdAt
        updatedAt
      }
      user {
        name
        email
        contactNumber
      }
      bgAccount {
        organization
        location
        teamSize
        companySize
        industry
        registeredAddress
        typeOfCompany
        dateOfIncorporation
        businessContactNumber
        CIN
        PAN
        TAN
        GSTIN
      }
    }
  }
`

export const GET_FEATURES_LIST_BY_BG_ACCOUNT_ID = gql`
  query GetFeaturesListByBgAccountId($input: getFeaturesListByBgAccountIdInput!) {
    getFeaturesListByBgAccountId(input: $input) {
      numberOfBots
      dashboardAccess
      sessionsLimit
      uniqueEndUsers
      additionalConversationCost
      supportUsers
      reportingAnalytics
      language
      CRMIntegration
      additionalChannelntegration
      Intents
      paymentIntegration
      mapIntegraionAPI
      dataSecurity
      conversationHistory
      thirdPartyIntegration
      callToAction
      exportsLeads
      exportReport
      templateCustomization
      emailAndCallSupport
      leadGenerationForm
      multipleChatWindowsForLive_ChatPerUser
      ticketHistory
      blockUser
      visitorInsight
      preDefinedResponses
      liveChat
      whiteLabelRemoveBranding
      fileUploads
      additionalIntegrationPerWebsiteSameBot
    }
  }
`
export const GET_FORM_TEMPLATE_DETAILS = gql`
  query GetTemplates($input: GetAllTemplateDetailsInput!) {
    getFormTemplateDetails(input: $input) {
      status
      message
      data
    }
  }
`
export const GET_ALL_FORM_BUILDER_BY_BG_ACCOUNT_ID = gql`
  query GetAllFormBuilderByBgAccountId($input: GetAllFormDetailsByBgAccountInput!) {
    getAllFormBuilderByBgAccountId(input: $input) {
      status
      message
      data
    }
  }
`
export const GET_ALL_SAVED_FORM_DETAILS_BY_FORM_UUID = gql`
  query GetAllSavedFormDetailsByFormUuid($input: getAllformInput!) {
    getAllSavedFormDetailsByFormUuid(input: $input) {
      status
      message
      data
    }
  }
`
export const GET_FORM_BUILDER_DETAILS_BY_FORM_UUID = gql`
  query GetFormBuilderDetailsByFormUuid($input: getFormDetailsByFormUuid!) {
    getFormBuilderDetailsByFormUuid(input: $input) {
      message
      form {
        formUuid
        name
        formData
      }
    }
  }
`
export const GET_ALL_FRANCHISE = gql`
  query GetAllFranchise($input: GetAllFranchiseFilterInput) {
    getAllFranchise(input: $input) {
      count
      franchises {
        id
        name
        location
        teamSize
        companySize
        logo
        registeredAddress
        dateOfIncorporation
        businessContactNumber
        CIN
        PAN
        TAN
        GSTIN
        users {
          id
          name
          email
          status
          emailVerified
          department
          designation
          UserRole {
            roleId
            userId
          }
          franchiseId
        }
        clients {
          id
          organization
          location
          teamSize
          companySize
          industry
          logo
          registeredAddress
          typeOfCompany
          dateOfIncorporation
          businessContactNumber
          CIN
          PAN
          TAN
          GSTIN
        }
        franchiseAgreements {
          id
          content
          approved
        }
      }
    }
  }
`

export const GET_FRANCHISE = gql`
  query GetFranchise($input: GetBgAccountsByFranchiseInput) {
    getFranchise(input: $input) {
      id
      name
      location
      teamSize
      companySize
      logo
      registeredAddress
      dateOfIncorporation
      businessContactNumber
      CIN
      PAN
      TAN
      GSTIN
      users {
        id
        name
        email
        status
        emailVerified
        department
        designation
        UserRole {
          roleId
          userId
        }
        franchiseId
      }
      clients {
        id
        organization
        location
        teamSize
        companySize
        industry
        logo
        registeredAddress
        typeOfCompany
        dateOfIncorporation
        businessContactNumber
        CIN
        PAN
        TAN
        GSTIN
      }
      franchiseAgreements {
        id
        content
        approved
      }
    }
  }
`

export const GET_PACKAGE_BY_BG_ACCOUNT_ID = gql`
  query GetPackageByBgAccountId($input: getPackageByBgAccountInput) {
    getPackageByBgAccountId(input: $input) {
      clientPackageId
      bgAccountId
      packageFeatureId
      status
      startDate
      endDate
    }
  }
`

export const GET_FEATURE_BY_BG_ACCOUNT_ID = gql`
  query GetFeatureByBgAccountId($input: getFeaturesByBgAccountInput) {
    getFeatureByBgAccountId(input: $input) {
      bgAccountId
      package {
        package {
          packageName
          packageDescriptions
        }
        feature {
          featuresId
          numberOfBots
          dashboardAccess
          sessionsLimit
          uniqueEndUsers
          additionalConversationCost
          supportUsers
          reportingAnalytics
          language
          CRMIntegration
          additionalChannelntegration
          Intents
          paymentIntegration
          mapIntegraionAPI
          dataSecurity
          conversationHistory
          thirdPartyIntegration
          callToAction
          exportsLeads
          exportReport
          templateCustomization
          emailAndCallSupport
          leadGenerationForm
          multipleChatWindowsForLive_ChatPerUser
          ticketHistory
          blockUser
          visitorInsight
          preDefinedResponses
          liveChat
          whiteLabelRemoveBranding
          fileUploads
          additionalIntegrationPerWebsiteSameBot
          askingPrice
        }
      }
    }
  }
`
export const GET_COUNT_OF_CLIENT_USERS_ROLES_AND_PLANS = gql`
  query GetCountOfClientUsersRolesAndPlans {
    getCountOfClientUsersRolesAndPlans {
      totalBgAccountCount
      totalUsersCount
      totalRolesCount
      totalcreatedPlansCount
      totalUsersPlanCount
      ticketDetails {
        totalNumberOfTickets
        totalNumberOfOpenTickets
        totalnumberOfAssignedTickets
        totalNumberOfUnassignedTickets
        totalNumberOfInProgress
        totalNumberOfResolvedTickets
        totalNumberOfClosedTickets
      }
    }
  }
`
export const GET_ROLES_BY_SUPERADMIN = gql`
  query GetRolesBySuperadmin($input: getRolesInputType!) {
    getRolesBySuperadmin(input: $input) {
      roleId
      roleName
      isPhiAccess
      createdBy
      UpdatedBy
      createdAt
      updatedAt
      RolePermissions
      totalCount
    }
  }
`
export const GET_ALL_PACKAGE_AND_FEATURES_LIST = gql`
  query GetAllPackageAndFeturesList {
    getAllPackageAndFeturesList {
      status
      message
      data
    }
  }
`

export const GET_PERMISSIONS_BY_ROLE = gql`
  query GetPermissionsByRole($input: getPermissionsByRoleInput) {
    getPermissionsByRole(input: $input) {
      status
      message
      data
    }
  }
`

export const GET_BILL_DETAILS = gql`
  query GetBillDetails($input: getBillDetailsInputType) {
    getBillDetails(input: $input) {
      billId
      clientPackageId
      invoiceNumber
      bgAccountId
      PackageStatus
      PlanStartDate
      ExpiryDate
      renewalDate
      packageAmount
      amountPaid
      currencyType
      modeofpayment
      paymentGateway
      paymentReferenceID
      paymentBankname
      paymentBankOtherDetails
      paymentRemarks
      discountApproval
      pdfLocation
      discountAmount
      paymentDate
      createdBy
      createdAt
      updatedBy
      updatedAt
      totalCount
      clientPackage {
        package {
          package {
            packageType {
              typeName
            }
          }
        }
      }
    }
  }
`

export const GET_CURRENT_PLAN_AND_BILLING_DETAILS_BY_BG_ACCOUNT = gql`
  query GetcurrentPlanAndBillingDetailsByBgAccount($input: getCurrentPlanAndBillingDetailsInput) {
    getcurrentPlanAndBillingDetailsByBgAccount(input: $input) {
      clientPackageId
      bgAccountId
      packageFeatureId
      status
      startDate
      endDate
      client {
        id
        users {
          name
          id
          email
          contactNumber
          UserRole {
            userId
            roleId
          }
        }
      }
      package {
        package {
          packageId
          packageName
          packageDescriptions
          packageAmount
          packageCategory
          packageTypeId
          packageDuration
          packageExpiryDate
          permissions
        }
        feature {
          featuresId
          numberOfBots
          dashboardAccess
          sessionsLimit
          uniqueEndUsers
          additionalConversationCost
          supportUsers
          reportingAnalytics
          language
          CRMIntegration
          additionalChannelntegration
          Intents
          paymentIntegration
          mapIntegraionAPI
          dataSecurity
          conversationHistory
          thirdPartyIntegration
          callToAction
          exportsLeads
          exportReport
          templateCustomization
          emailAndCallSupport
          leadGenerationForm
          multipleChatWindowsForLive_ChatPerUser
          ticketHistory
          blockUser
          visitorInsight
          preDefinedResponses
          liveChat
          whiteLabelRemoveBranding
          fileUploads
          additionalIntegrationPerWebsiteSameBot
          askingPrice
        }
      }
    }
  }
`
export const GET_AMOUNT_FOR_SELECTED_PLAN = gql`
  query GetAmountForSelectedPlan($input: getAmountForSelectedPlanInput) {
    getAmountForSelectedPlan(input: $input) {
      status
      message
      data
    }
  }
`
export const GET_BILLING_HISTORY_BY_BG_ACCOUNT = gql`
  query GetBillingHistoryByBgAccount($input: getBillingHistoryByBgAccountInput) {
    getBillingHistoryByBgAccount(input: $input) {
      allBillingHistory {
        id
        billId
        invoiceNumber
        bgAccountId
        clientPackageId
        packageStatus
        planStartDate
        expiryDate
        renewalDate
        packageAmount
        discountAmount
        amountPaid
        currencyType
        paymentStatus
        modeofpayment
        paymentGateway
        paymentDate
        paymentReferenceID
        paymentBankname
        paymentBankOtherDetails
        paymentRemarks
        discountApproval
        pdfLocation
        createdBy
        createdAt
        updatedBy
        updatedAt
        packageName
      }
      totalCount
    }
  }
`

export const GET_CLIENT_PACKAGE_HISTORY_BY_BG_ACCOUNT = gql`
  query GetClientPackageHistoryByBgAccount($input: getClientPackageHistoryInputType) {
    getClientPackageHistoryByBgAccount(input: $input) {
      totalCount
      allClientPackageHistory {
        clientPackageHistoryId
        clientPackageId
        bgAccountId
        packageFeatureId
        billingHistoryId
        status
        startDate
        endDate
        packageId
        packageName
        packageDescriptions
        packageAmount
        packageCategory
      }
    }
  }
`

export const GET_ALL_CURRENT_BILL_DETAILS = gql`
  query GetAllCurrentBillDetails($input: getAllCurrentBillDetailsInput) {
    getAllCurrentBillDetails(input: $input) {
      currentMonthAllBillDetails {
        billId
        invoiceNumber
        bgAccountId
        clientPackageId
        packageStatus
        planStartDate
        expiryDate
        renewalDate
        packageAmount
        discountAmount
        amountPaid
        currencyType
        paymentStatus
        modeofpayment
        paymentGateway
        paymentDate
        paymentReferenceID
        paymentBankname
        paymentBankOtherDetails
        paymentRemarks
        discountApproval
        pdfLocation
        createdBy
        clientPackage {
          package {
            package {
              packageId
              packageName
              packageDescriptions
              packageAmount
              packageCategory
              packageTypeId
              packageDuration
              packageExpiryDate
              permissions
              createdBy
              createdAt
              updatedBy
              updatedAt
            }
            feature {
              featuresId
              numberOfBots
              dashboardAccess
              sessionsLimit
              uniqueEndUsers
              additionalConversationCost
              supportUsers
              reportingAnalytics
              language
              CRMIntegration
              additionalChannelntegration
              Intents
              paymentIntegration
              mapIntegraionAPI
              dataSecurity
              conversationHistory
              thirdPartyIntegration
              callToAction
              exportsLeads
              exportReport
              templateCustomization
              emailAndCallSupport
              leadGenerationForm
              multipleChatWindowsForLive_ChatPerUser
              ticketHistory
              blockUser
              visitorInsight
              preDefinedResponses
              liveChat
              whiteLabelRemoveBranding
              fileUploads
              additionalIntegrationPerWebsiteSameBot
              botExpiry
              excelAnalytics
              askingPrice
              createdBy
              createdAt
              updatedBy
              updatedAt
            }
          }
          client {
            users {
              name
              email
            }
          }
        }
      }
      countAllBillDetails
    }
  }
`
export const GET_TICKET = gql`
  query GetTicketbyTicketNumber($input: getTicketInput!) {
    getTicketbyTicketNumber(input: $input) {
      typeId
      typeName
      typeDescription
      bgAccountId
      createdBy
      createdDt
      updatedBy
      updatedDt
    }
  }
`

export const GET_STATUS = gql`
  query GetAllStatus {
    getAllStatus {
      statusId
    }
  }
`

export const GET_TICKET_BY_BGACCOUNT = gql`
  query GetAllTicketsbyBgaccount {
    getAllTicketsbyBgaccount {
      id
      ticketNumber
      TypeId
      PriorityId
      StatusId
      title
      description
      resolution
      oldTicketId
      attachmentId
      userId
      bgAccountId
      closureDateTime
      SupportEngineerId
      supportEngineerName
      createdAt
      updatedAt
    }
  }
`

export const GET_TICKET_BY_STATUS_INPUT = gql`
  query GetTicketbyStatus($input: getTicketsByStatusInput!) {
    getTicketbyStatus(input: $input) {
      ticketcount
      tickets {
        id
        ticketNumber
        TypeId
        PriorityId
        StatusId
        title
        description
        resolution
        oldTicketId
        attachmentId
        userId
        bgAccountId
        closureDateTime
        SupportEngineerId
        supportEngineerName
        createdAt
        updatedAt
      }
    }
  }
`

export const GET_ALL_SUPPORT_ID = gql`
  query GetAllSupportEngineers {
    getAllSupportEngineers {
      userId
      name
    }
  }
`

export const GET_ALL_SUPPORT_TICKETS = gql`
  query GetAllSupportEngineerTickets {
    getAllSupportEngineerTickets {
      id
      ticketNumber
      TypeId
      PriorityId
      StatusId
      title
      description
      resolution
      oldTicketId
      attachmentId
      userId
      bgAccountId
      closureDateTime
      supportEngineerId
      createdAt
      updatedAt
    }
  }
`
export const GET_ALL_TICKET_HISTORY = gql`
  query GetAllTicketHistory {
    getAllTicketHistory {
      id
      ticketNumber
      TypeId
      PriorityId
      StatusId
      title
      description
      resolution
      oldTicketId
      attachmentId
      userId
      bgAccountId
      closureDateTime
      supportEngineerId
      createdAt
      updatedAt
      supportEngineerName
    }
  }
`

export const GET_TOTAL_NUMBER_OF_TICKET = gql`
  query GetNumberOfTickets {
    getNumberOfTickets {
      numberOfOpenTickets
      numberOfResolvedTickets
      numberOfAssignedTickets
      numberOfUnassignedTickets
      numberOfInProgress
      numberOfTickets
      numberOfPendingTickets
    }
  }
`

export const GET_SESSION_BY_BG_ACCOUNT_ID = gql`
  query GetSessionByBgaccountId($input: getSessionByBgaccountIdInput!) {
    getSessionByBgaccountId(input: $input) {
      id
      chatRoomId
      assignedAgentId
      connectionId
      timedOut
      createdAt
      modifiedAt
      deletedAt
      startDate
      endDate
      reslovedBy
      chatRoom {
        chatName {
          time
          agentId
          bgAccountId
          applicationId
        }
      }
      botName
      agentName
    }
  }
`
export const SEARCH_TICKETS = gql`
  query GetAllTicketsbyBgaccount($input: searchTicketsInput) {
    getAllTicketsbyBgaccount {
      id
      ticketNumber
      TypeId
      PriorityId
      StatusId
      title
      description
      resolution
      oldTicketId
      attachmentId
      userId
      bgAccountId
      closureDateTime
      supportEngineerId
      supportEngineerName
      createdAt
      updatedAt
    }
    findTicketDetails(input: $input) {
      status
      message
      data
    }
  }
`

export const GET_ALL_TEAMS_AND_USERS = gql`
  query GetAllTeamsAndUsers($input: getAllTeamsAndUsersInput) {
    getAllTeamsAndUsers(input: $input) {
      status
      message
      data
    }
  }
`

export const GET_WHITE_LABELING_BY_ID = gql`
  query GetWhiteLabelingbyId($input: getWhiteLabelingByIdInputType) {
    getWhiteLabelingbyId(input: $input) {
      ... on WhiteLabel {
        id
        bgAccountId
        logo
        copyright
        companyName
      }
      ... on Error {
        message
      }
    }
  }
`

export const GET_MODULE_ACESS_BY_ROLE = gql`
  query GetModuleAcessByRole($input: getModuleAcessByRoleInput!) {
    getModuleAcessByRole(input: $input) {
      status
      message
      data
    }
  }
`

export const GET_ALL_MODULES = gql`
  query GetAllModules($input: getAllModulesInput!) {
    getAllModules(input: $input) {
      status
      message
      data
    }
  }
`

export const GET_API_URLS = gql`
  query GetApiUrls($input: getApiURLInput!) {
    getApiUrls(input: $input) {
      message
      name
      apiUrls
      sideMenu
      permission
    }
  }
`

export const GET_ALL_EMAIL_CONFIG_BY_BG_ACCOUNT_ID = gql`
  query GetAllEmailonfigByBgAccountId($input: GetAllEmailConfigByBgAccountInput!) {
    getAllEmailonfigByBgAccountId(input: $input) {
      bgAccountId
      email
      hostName
      port
      userName
      password
      ssl
      tls
    }
  }
`

export const GET_SF_AUTH_DETAILS_BY_BG_ACCOUNT = gql`
  query GetSfAuthDetailsByBgAccountId($input: getSfAuthDetailsInputType) {
    getSfAuthDetailsByBgAccountId(input: $input) {
      id
      externalServiceId
      bgAccountId
      sfClientId
      sfClientSecretId
      sfUsername
      password
      accessToken
      instanceUrl
      tokenType
      issuedAt
    }
  }
`

export const GET_API_LIST_BY_SERVICE_NAME = gql`
  query GetApiListByServiceName($input: getApiListByServiceNameInputType) {
    getApiListByServiceName(input: $input) {
      id
      serviceName
      apiList
    }
  }
`

export const GET_INTERNAL_CHAT_ID = gql`
  query GetInternalChatId($input: internalChatIdInput!) {
    getInternalChatId(input: $input) {
      status
      message
      data
    }
  }
`

export const GET_ALL_MAPS = gql`
  query GetallMaps {
    getallMaps {
      id
      bgAccountId
      services
      configName
      value
    }
  }
`

export const GET_ALL_EXTERNAL_SERVICES = gql`
  query GetAllExternalServices {
    getAllExternalServices {
      id
      name
      serviceDescription
    }
  }
`

export const GET_TEAMS_CONFIG_BY_BG_ACCOUNT = gql`
  query GetTeamsConfigByBgAccountId($input: GetConfigDetailsByBgAccountIdInputType!) {
    getTeamsConfigByBgAccountId(input: $input) {
      bgAccountId
      externalServiceId
      clientId
      clientSecret
      tenantId
      redirectUri
      scope
    }
  }
`

export const GET_GOOGLE_MEET_CONFIG_BY_BG_ACCOUNT = gql`
  query GetGoogleMeetConfigByBgAccountI($input: GetConfigDetailsByBgAccountIdInputType!) {
    getGoogleMeetConfigByBgAccountI(input: $input) {
      bgAccountId
      externalServiceId
      clientId
      clientSecret
      tenantId
      redirectUrl
      googleCalendarId
    }
  }
`
export const GET_ASSIGNED_TEAM_BY_USER_ID = gql`
  query GetAssignedTeamByUserId($input: getAssignedTeamByuserIdInput!) {
    getAssignedTeamByUserId(input: $input) {
      bgaccountId
      userId
      teamId
      Team
    }
  }
`

export const GET_RAZOR_PAY_PAYMENT_CONFIG = gql`
  query GetRazorPayPaymentConfig {
    getRazorPayPaymentConfig {
      status
      message
      data
    }
  }
`

export const GET_PAYPAL_PAYMENT_CONFIG = gql`
  query GetPaypalPaymentConfig {
    getPaypalPaymentConfig {
      status
      message
      data
    }
  }
`

export const GET_RAZOR_ALL_TRANSATIONS = gql`
  query GetRazorAllTransations($input: allTransationRazorPayInput!) {
    getRazorAllTransations(input: $input) {
      status
      message
      data
    }
  }
`
export const GET_ALL_PAYPAL_TRANSATION = gql`
  query GetAllPayPalTransation($input: allTransationPayPalInput!) {
    getAllPayPalTransation(input: $input) {
      status
      message
      data
    }
  }
`

export const GET_BOT_FORM_RESPONSE = gql`
  query GetbotFormResponse($input: getBotFormInput_Type!) {
    getbotFormResponse(input: $input) {
      data {
        id
        bgAccountId
        appIdString
        name
        type
        payload
        response
        intentData
        result
        createdAt
        updatedAt
        loginUserId
        chatRoomId
      }
      total
      page
      limit
      totalPages
    }
  }
`

export const GET_TRANSLATED_JSON_BY_LG = gql`
  query GetTranslatedJsonByLg($input: getTranslatedJsonByLgInput!) {
    getTranslatedJsonByLg(input: $input) {
      status
      message
      data
    }
  }
`

export const GET_TEAMS_WITH_UNREAD_COUNT = gql`
  query GetTeamsWithUnreadCounts {
    getTeamsWithUnreadCounts {
      id
      name
      members {
        id
        name
        email
        unreadCount
      }
    }
  }
`

export const GET_DEPENDENT_FORM_DETAILS = gql`
  query GetDependentFormDetails($input: GetDependentFormDetailsInput!) {
    getDependentFormDetails(input: $input) {
      message
      form {
        isDependent
        dependentFormUuid
        senderEmail
        recipientEmails
        shareableLink
        customMessage
        formsFields
      }
    }
  }
`

export const GET_PREFILL_RECIPIENTS = gql`
  query GetPrefillRecipients($input: GetPrefillRecipientsInput!) {
    getPrefillRecipients(input: $input) {
      total
      stats {
        total
        pending
        queued
        sent
        submitted
        failed
        totalMailsSent
      }
      recipients {
        recipientUuid
        batchUuid
        recipientEmail
        recipientName
        shareableLink
        status
        prefillData
        sentMailCount
        sentAt
        openedAt
        submittedAt
        saveFormUuid
        createdAt
      }
    }
  }
`

export const GET_PREFILL_BATCHES = gql`
  query GetPrefillBatches($input: GetPrefillBatchesInput!) {
    getPrefillBatches(input: $input) {
      batches {
        batchUuid
        fileName
        totalRows
        createdAt
      }
    }
  }
`

export const GET_USER_EMAIL_SIGNATURE = gql`
  query GetUserEmailSignature {
    getUserEmailSignature {
      hasSignature
      signatureHtml
      message
    }
  }
`

export const GET_BOT_FORM_RESPONSE_BY_DATE_RANGE = gql`
  query GetbotFormResponseExcelData($input: getBotFormExcelInput_Type!) {
    getbotFormResponseExcelData(input: $input) {
      status
      message
      data
    }
  }
`
